import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ShopProvider } from "./lib/shop";

/* Fashion storefront */
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import AdminShop from "./pages/AdminShop";
import Login from "./pages/Login";
import Categories from "./pages/Categories";
import BottomNav from "./components/BottomNav";
import {
  SizeGuide, Contact,
  NotFound, Wishlist, Account,
} from "./pages/StaticPages";
import OurStory from "./pages/OurStory";
import { Faq, Shipping, Returns, Privacy, Terms, CancellationRefund } from "./pages/Policies";

function App() {
  return (
    <div className="App">
      <ShopProvider>
        <BrowserRouter>
          <Routes>
            {/* Store */}
            <Route path="/"                     element={<Home />} />
            <Route path="/shop"                 element={<Shop />} />
            <Route path="/shop/:collection"     element={<Shop />} />
            <Route path="/shop/product/:slug"   element={<ProductDetail />} />
            <Route path="/cart"                 element={<Cart />} />
            <Route path="/checkout"             element={<Checkout />} />
            <Route path="/order/:id"            element={<OrderConfirmation />} />
            <Route path="/categories"           element={<Categories />} />
            <Route path="/wishlist"             element={<Wishlist />} />
            <Route path="/account"              element={<Account />} />

            {/* Account / auth */}
            <Route path="/login"                element={<Login />} />

            {/* Policies & content */}
            <Route path="/our-story"            element={<OurStory />} />
            <Route path="/about"                element={<Navigate to="/our-story" replace />} />
            <Route path="/contact"              element={<Contact />} />
            <Route path="/faq"                  element={<Faq />} />
            <Route path="/size-guide"           element={<SizeGuide />} />
            <Route path="/shipping"             element={<Shipping />} />
            <Route path="/returns"              element={<Returns />} />
            <Route path="/privacy-policy"       element={<Privacy />} />
            <Route path="/terms"                element={<Terms />} />
            <Route path="/cancellation-refund"  element={<CancellationRefund />} />

            {/* Admin */}
            <Route path="/admin"                element={<AdminShop />} />

            {/* Education legacy → redirect everything to home */}
            <Route path="/dashboard"            element={<Navigate to="/account" replace />} />
            <Route path="/certifications"       element={<Navigate to="/" replace />} />
            <Route path="/courses/*"            element={<Navigate to="/" replace />} />
            <Route path="/industrial-training/*" element={<Navigate to="/" replace />} />
            <Route path="/college-integration"  element={<Navigate to="/" replace />} />
            <Route path="/corporate-integration" element={<Navigate to="/" replace />} />
            <Route path="/code-ide"             element={<Navigate to="/" replace />} />
            <Route path="/community/*"          element={<Navigate to="/" replace />} />
            <Route path="/career-consultancy"   element={<Navigate to="/" replace />} />
            <Route path="/seminars-webinars"    element={<Navigate to="/" replace />} />
            <Route path="/verify/*"             element={<Navigate to="/" replace />} />

            <Route path="*"                     element={<NotFound />} />
          </Routes>
          <BottomNav />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </ShopProvider>
    </div>
  );
}

export default App;
